<template>
  <section class="noData_container">
    <div class="result_content">
      <div class="result_title">商务合作</div>
    </div>
    <van-image width="90%" height="90%" style="margin:0 auto" :src="result_icon" />
    <div class="wx">
      <div class="wxbox">
        <div class="wxbox_user">
          <div class="wxbox_user_name">
            <van-image width="60" height="60" :src="Boss" />
            <div style="margin-left:20px">
              <div class="wxbox_user_name_w">王经理</div>
              <div class="wxbox_user_name_t">车场合作</div>
            </div>
          </div>
          <div class="wxbox_user_company">江苏九比特信息系统有限公司</div>
        </div>
        <div>
          <van-image width="100" height="100" :src="BossCode" />
        </div>
      </div>
      <!-- <van-divider :style="{ borderColor: '#969799' }">
        联系方式
      </van-divider> -->
      <!-- <div class="wxbox_phone">
        <a :href="`tel:${phone}`">{{phone}} </a>

      </div> -->
    </div>
  </section>
</template>

<script>
import noData from '@/assets/insurance_images/bus.png'
import boss from '@/assets/insurance_images/boss.png'
import bossCode from '@/assets/insurance_images/bossCode.png'
import config from '@/config/index'
import { Divider } from 'vant'
import { mapGetters } from 'vuex'
export default {
  components: {
    [Divider.name]: Divider
  },
  computed: {

  },
  data () {
    return {
      phone: '17761747990',
      config,
      result_icon: noData,
      Boss: boss,
      BossCode: bossCode,
    }
  },
  methods: {
    // 辅助查询
    auxiliarySearch () {
      this.$router.push({ name: 'Arrears-Bill-Index' })
    }
  }
}
</script>

<style lang="scss" scoped>
.noData_container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: -webkit-linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 10%,
    #83bdf6 20%,
    #9bc5f0 30%,
    #e0f4fb 70%,
    #ffffff 100%
  );
  background: -ms-linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 10%,
    #83bdf6 20%,
    #9bc5f0 30%,
    #e0f4fb 70%,
    #ffffff 100%
  );
  background: -moz-linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 10%,
    #83bdf6 20%,
    #9bc5f0 30%,
    #e0f4fb 70%,
    #ffffff 100%
  );
  background: linear-gradient(
    top,
    #5187f5 0%,
    #5dabf8 10%,
    #83bdf6 20%,
    #9bc5f0 30%,
    #e0f4fb 70%,
    #ffffff 100%
  );
  background-size: 100% auto;
  background-repeat: no-repeat;
  // background-position-y: 100%;
  .result_content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    height: px2rem(100);
    text-align: center;
    .result_title {
      color: white;
      height: px2rem(40);
      line-height: px2rem(50);
      font-size: px2rem(26);
    }
  }
  .wx {
    background: white;
    border-radius: 3px;
    margin: 10px;
    padding: 20px;
    box-shadow: rgb(182, 182, 182) 1px 5px 10px;
  }
  .wxbox {
    display: flex;
    justify-content: space-between;
    &_phone {
      font-size: px2rem(14);
      text-align: center;
    }
    &_user {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      &_name {
        display: flex;
        &_w {
          font-size: px2rem(22);
        }
        &_t {
          font-size: px2rem(15);
        }
      }
      &_company {
        font-size: px2rem(14);
        color: rgb(180, 180, 180);
      }
    }
  }
}
</style>